import { useEffect, createContext, useContext } from "react";
import { useShoppingCart } from "./shopping-cart-hooks";
import { useContextKeycloak } from "@/app/module/keycloak/index";

type ContextShoppingCartType = ReturnType<typeof useShoppingCart>;
export const marketplaceShoppingCartContext =
  createContext<ContextShoppingCartType | null>(null);

export function useContextShoppingCart() {
  const context = useContext(marketplaceShoppingCartContext);

  if (!context) {
    throw new Error(
      "useContextShoppingCart must be used within a ContextShoppingCartProvider",
    );
  }

  return context;
}

export function ContextShoppingCartProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const marketplaceShoppingCart = useShoppingCart();
  const { fetchShoppingCart, marketplaceCartData } = marketplaceShoppingCart;
  const { authorize } = useContextKeycloak();

  useEffect(() => {
    if (authorize) {
      fetchShoppingCart().catch(console.error);
    }
  }, [authorize]);

  if (authorize && !marketplaceCartData) {
    return null;
  }

  return (
    <marketplaceShoppingCartContext.Provider value={marketplaceShoppingCart}>
      {children}
    </marketplaceShoppingCartContext.Provider>
  );
}
